import { Component, EventEmitter, Input, Output } from "@angular/core";
import { GroupSlot } from "src/app/pages/interviews/pages/interview-details/group-slots.interface";

@Component({
  selector: 'group-slot',
  template: `
    <div class="block tablet:flex justify-between items-center">
      <div class="block tablet:flex items-center gap-2">
        <interview-date-widget
          [meeting]="meetingSlot"
          [disabled]="disabled"
          [className]="'block mb-5 tablet:mb-0'"
        ></interview-date-widget>
        <div class="flex gap-2 items-center">
          <interview-time-widget
            [meeting]="meetingSlot"
            [disabled]="disabled"
            [className]="'block mb-5 tablet:mb-0'"
          ></interview-time-widget>
          <span class="text-4 mb-5 tablet:mb-0" [ngClass]="{'text-neutral-300': disabled, 'text-neutral-500': !disabled}">({{formatDuration(meetingSlot.startDate.local.localeTime, meetingSlot.endDate.local.localeTime)}})</span>
        </div>
      </div>
      <ng-container *ngIf="!groupSlotChoiceMode else confirm">
        <div class="flex gap-4 items-center">
          <talos-forms-button type="cancel" text="Cancel" (buttonClick)="cancelConfirmation()"></talos-forms-button>
          <talos-forms-button type="primary" [inline]="false" text="Confirm Interview" class="flex-1" (buttonClick)="clickConfirmInterview()"></talos-forms-button>
        </div>
      </ng-container>
      <ng-template #confirm>
        <talos-forms-button type="secondary-alt" [inline]="false" text="Choose this slot" [disabled]="disabled" (buttonClick)="toggleGroupSlotChoiceMode(false)"></talos-forms-button>
      </ng-template>
    </div>
  `,
  standalone: false,
})
export class GroupSlotComponent {
  @Input() meetingSlot!: GroupSlot;
  @Input() disabled: boolean = false;

  @Output() confirmationClicked = new EventEmitter<void>();
  @Output() slotChosenClicked = new EventEmitter<void>();
  @Output() cancelClicked = new EventEmitter<void>();

  public groupSlotChoiceMode: boolean = true;

  constructor() {
  }

  public cancelConfirmation() {
    this.toggleGroupSlotChoiceMode(true);
    this.cancelClicked.emit();
  }

  public clickConfirmInterview() {
    this.confirmationClicked.emit();
  }

  public toggleGroupSlotChoiceMode(enabled: boolean): void {
    this.groupSlotChoiceMode = enabled;
    this.slotChosenClicked.emit();
  }

  public formatDuration(startTime: string, endTime: string): string {
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);
  
    const startDate = new Date();
    startDate.setHours(startHour, startMinute, 0, 0);
  
    const endDate = new Date();
    endDate.setHours(endHour, endMinute, 0, 0);
  
    let diffMs = endDate.getTime() - startDate.getTime();
  
    const totalMinutes = diffMs / (1000 * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    if (hours > 0 && minutes > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} min${minutes > 1 ? 's' : ''}`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''}`;
    } else {
      return `${minutes} min${minutes > 1 ? 's' : ''}`;
    }
  }  
}